module.exports = __webpack_public_path__ + "img/downx3.85f2d419.svg";